import { OneVerifyApplicationRole } from "@common-shared/config/rolesPermissions.config"

import type { ISelectRenderedOption } from "@front-shared/types/objects.types"

export const ROLES_PERMISSIONS_CONFIG = {
    inviteRenderedRoles: [
        {
            value: OneVerifyApplicationRole.practiceAdmin,
            displayValue: "Admin",
            dropdownDisplayValue: "Admin",
        },
        {
            value: OneVerifyApplicationRole.practiceBiller,
            displayValue: "Biller",
            dropdownDisplayValue: "Biller",
        },
    ] as ISelectRenderedOption[],
}
